import React, { useState } from 'react';
import { PathList, PathToggle, Muted } from './security.styled';

// Plafond de collecte : la requête Defender fait `make_set(DiskPaths, 50)`.
// Une cellule à 50 chemins en compte donc peut-être davantage, et le dire évite
// de laisser croire que la liste est exhaustive.
const COLLECTION_CAP = 50;

// En dessous de ce seuil la liste s'affiche directement. Mesuré le 2026-08-27
// sur cns-wks-fpr-2 : huit lignes du top sur dix ont 1 à 3 chemins, les deux
// autres en ont 50. Replier systématiquement aurait ajouté un clic pour rien
// dans la grande majorité des cas.
const SEUIL_INLINE = 4;

/**
 * Cellule de chemins disque ou registre. Courte, elle s'affiche telle quelle ;
 * longue, elle se replie derrière un compteur dépliable — un conteneur défilant
 * de six lignes ne montrait que 12 % d'une cellule à 50 chemins.
 */
export default function PathCell({ paths }) {
    const [expanded, setExpanded] = useState(false);
    const liste = paths || [];

    if (liste.length === 0) return <Muted>—</Muted>;

    if (liste.length <= SEUIL_INLINE) {
        return (
            <PathList>
                {liste.map((p) => <span key={p} title={p}>{p}</span>)}
            </PathList>
        );
    }

    const plafonne = liste.length >= COLLECTION_CAP;

    return (
        <>
            <PathToggle
                type="button"
                // Dans la fiche appareil, la ligne du tableau est cliquable et
                // navigue vers la fiche CVE : sans cet arrêt de propagation,
                // déplier la liste quitterait la page.
                onClick={(event) => { event.stopPropagation(); setExpanded((o) => !o); }}
                title={plafonne
                    ? `${liste.length} chemins collectés. La requête Defender plafonne à ${COLLECTION_CAP} : il peut y en avoir davantage sur le poste.`
                    : `Afficher les ${liste.length} chemins`}
            >
                <i className={expanded ? 'bx bx-chevron-down' : 'bx bx-chevron-right'} />
                {liste.length}{plafonne ? '+' : ''} chemins
            </PathToggle>

            {expanded && (
                <PathList $expanded style={{ marginTop: '6px' }}>
                    {liste.map((p) => <span key={p} title={p}>{p}</span>)}
                </PathList>
            )}
        </>
    );
}
